import React from 'react';
import { Badge } from 'react-bootstrap';

export default function LabelBadge({ labelName }: { labelName: string }) {
  return (
    <Badge
      style={{
        whiteSpace: 'normal',
        alignSelf: 'center',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '16px',
        background: 'linear-gradient(0deg, #6CA8FF, #6CA8FF), #FFFFFF',
      }}
      pill
      text="light"
    >
      #
      {labelName}
    </Badge>
  );
}
